import React, { useState } from 'react';

const dealersData = [
    {
        city: "AHMEDABAD",
        dealers: [
            { name: "Karnavati Law House", contact: "26578319, 55310401, 30021415, 26576299 - 9327008283" },
            { name: "Standard Book Distributors", contact: "27540731, 27540732 - 9327059872" },
            { name: "Puja Law House", contact: "9924119329" },
            { name: "Rushab Traders", contact: "9377781009" },
            { name: "Capital Law House", contact: "9825275918" }
        ]
    },
    {
        city: "ALLAHABAD",
        dealers: [
            { name: "Alia Law Agency", contact: "2560444, 2560555, 2560666 - 9415216677" },
            { name: "Dwivedi Law Publications", contact: "2422510, 2422511" },
            { name: "Modern Law House", contact: "2560616, 2560700 - 9335106213" },
            { name: "Modern Law Publication", contact: "2560905, 2560906 - 9414344857" },
            { name: "New Loyal Book Agency - Mr. R.K Tiwari", contact: "9415217399" },
            { name: "Law Publisher", contact: "2622758, 2622781" }
        ]
    },
    {
        city: "AMRITSAR",
        dealers: [
            { name: "Supreme Law Agency", contact: "2584548, 2586652 - 9414344857" },
            { name: "Shankar Law Book Agency", contact: "2552301, 9872981081" }
        ]
    },
    {
        city: "AURANGABAD",
        dealers: [
            { name: "Nasik Law House", contact: "2487931" }
        ]
    },
    {
        city: "BAHADURGARH",
        dealers: [
            { name: "Naveen Law House", contact: "951276-234618; 09812087789" }
        ]
    },
    {
        city: "BANGALORE",
        dealers: [
            { name: "Ganesh Book Bureau", contact: "5551145 - 9845266516" },
            { name: "Konark Law Publications", contact: "22254986, 22261133 - 9341773397" },
            { name: "Law Link Publications", contact: "22263434 - 9845057996" },
            { name: "M.P.P. House", contact: "22260706, 22265901 - 9845021835" },
            { name: "Puliani & Puliani", contact: "22254052, 22265500, 22257223 - 9845055242" },
            { name: "Premier Book House", contact: "9845073227" }
        ]
    },
    {
        city: "BARODA",
        dealers: [
            { name: "Hemdip Agencies", contact: "2422603, 2337503 - 9824649888" },
            { name: "Pragati Law Agencies", contact: "2333205" },
            { name: "Sagar Law House", contact: "2340933, 2350293" }
        ]
    },
    {
        city: "BHATINDA",
        dealers: [
            { name: "Shree Hanuman Ji Law House", contact: "212152" }
        ]
    },
    {
        city: "BHILAI",
        dealers: [
            { name: "Bharat Law Agency", contact: "5030128 - 9300206426" },
            { name: "Students Store", contact: "9893130334" }
        ]
    },
    {
        city: "BHOPAL",
        dealers: [
            { name: "Suvidha Law House", contact: "2551597, 2576204" },
            { name: "Law Point", contact: "9826649644" },
            { name: "Books & Books", contact: "2673602, 9826086858" },
            { name: "Ravinder Wadhwaney", contact: "9229549709" }
        ]
    },
    {
        city: "BHUBANESHWAR",
        dealers: [
            { name: "The Law", contact: "2394592, 94370815548" }
        ]
    },
    {
        city: "CALCUTTA",
        dealers: [
            { name: "Book & Books", contact: "22487136 - 9341695887" },
            { name: "Book Corporation", contact: "22205367, 22206669 - 9331000405" },
            { name: "Book-n-Trade", contact: "22489723" },
            { name: "Eastern Law House Pvt. Ltd.", contact: "22374989, 22372310 - 9830047224" },
            { name: "Kamal Law House", contact: "22208941, 22488077 - 9831015096" },
            { name: "Law Point", contact: "22483934, 22101821 - 9433095401" },
            { name: "S. C. Sarkar & Sons Pvt. Ltd.", contact: "2416305" },
            { name: "Swastik Books", contact: "22483146, 22104605, 22436010" },
            { name: "Tax N Law", contact: "22427092, 22482904 - 9836920692" },
            { name: "Venus Book Distributors", contact: "22483146, 22104605 - 9433086736" }
        ]
    },
    {
        city: "CALICUT",
        dealers: [
            { name: "Krishnageetha Law Bok House", contact: "9747290900, 9745240065, 9446734026, 9037734026" },
            { name: "Southern Law House", contact: "27246864" }
        ]
    },
    {
        city: "CHANDIGARH",
        dealers: [
            { name: "Gopal Law Agency", contact: "2703736 - 9876907930" },
            { name: "Jain Law Agency", contact: "2701615" },
            { name: "Shree Ram Law House", contact: "2709277, 5077137 - 9815844552" },
            { name: "University Book Depot", contact: "2703273" }
        ]
    },
    {
        city: "CHENNAI",
        dealers: [
            { name: "C. Sitaraman & Co.", contact: "28111516, 28117069, 28112990 - 9841011516" }
        ]
    },
    {
        city: "COIMBATORE",
        dealers: [
            { name: "Lakshmi Law House", contact: "234199 - 9842223419" },
            { name: "V.Angamuthu", contact: "2301136, 2211585 - 9443383047" }
        ]
    },
    {
        city: "CUTTACK",
        dealers: [
            { name: "Cuttack Law House", contact: "2609372 - 9238574104" },
            { name: "Puja Law Agency", contact: "2368027" }
        ]
    },
    {
        city: "GHAZIABAD",
        dealers: [
            { name: "Anshu Law House", contact: "2781258 - 9810903484" },
            { name: "Laxmi Law House", contact: "2759012 - 9810579939" }
        ]
    },
    {
        city: "GWALIOR",
        dealers: [
            { name: "Grover Law House", contact: "2322907, 5077533 - 9893393605" },
            { name: "Wadhwa Law House", contact: "2324042 - 9425187191" }
        ]
    },
    {
        city: "HYDERABAD",
        dealers: [
            { name: "A.L.T. Publications", contact: "24045358, 24042555, 24529301 - 9849408118" },
            { name: "Ashok Law House", contact: "24755059, 24754654 - 9440969240" },
            { name: "Asia Law Publications", contact: "24566212, 24526212, 24520276 - 9849025942" },
            { name: "Gogia Law Agency", contact: "24525689, 24560631 - 9849024853" },
            { name: "Law Publico Pvt. Ltd.", contact: "24613894, 55337576, 24754151 - 9848092800" },
            { name: "S. Gogia & Co.", contact: "23237960, 23230747, HC-24565769 - 9849024853" },
            { name: "Srinivas Law House", contact: "27710349 - 9848020254" },
            { name: "Tulsi Law Agency", contact: "24413091, 55703091 - 9848010169" },
            { name: "Narender Goiga & Co.", contact: "23237960, 23230747" }
        ]
    },
    {
        city: "INDORE",
        dealers: [
            { name: "Legal Book House", contact: "2543506 - 9425057699" },
            { name: "Progressive Legal Agency", contact: "2526674, 5072225" },
            { name: "Vedpal Law House", contact: "2543491, 2543493" },
            { name: "Wadhwa & Co.", contact: "2541868" }
        ]
    },
    {
        city: "JABALPUR",
        dealers: [
            { name: "Hind Law Agency", contact: "2625642, 5016534 - 8878325586" },
            { name: "Jabalpur Law House", contact: "2625637, 2519018 - 9425356843" }
        ]
    },
    {
        city: "JAIPUR",
        dealers: [
            { name: "Bharat Law House", contact: "2316388, 2321388 - 9314526388" },
            { name: "Current Law House", contact: "2317842 - 9314506199" },
            { name: "Mehta Pustak Bhandar", contact: "2571825, 2563431" },
            { name: "Western Law Book Co.", contact: "2563440 - 9829056344" }
        ]
    },
    {
        city: "JALLANDHAR",
        dealers: [
            { name: "Supreme Law Agency", contact: "5086008 - 9855480441" }
        ]
    },
    {
        city: "JODHPUR",
        dealers: [
            { name: "Book N CD", contact: "2441964" },
            { name: "Prakash Law House", contact: "2627658 - 9414132658" },
            { name: "Rajasthan Law House", contact: "2547336, 2547965" },
            { name: "Sachdeva Law Agency", contact: "2637739" }
        ]
    },
    {
        city: "KANPUR",
        dealers: [
            { name: "Law Book Emporium", contact: "2304417" },
            { name: "Kishore Book Depot", contact: "2366839" }
        ]
    },
    {
        city: "KOCHI",
        dealers: [
            { name: "Law Book Shop", contact: "2397895, 2398484 - 9447768991" },
            { name: "Swamy Law House", contact: "2361341, 2366285 - 9446461341" },
            { name: "Law Books Avenue", contact: "2384949, 9447144349" }
        ]
    },
    {
        city: "KOZHIKODE",
        dealers: [
            { name: "Krishnageetha Law Bok House", contact: "9747290900, 9745240065, 9446734026, 9037734026" }
        ]
    },
    {
        city: "LUCKNOW",
        dealers: [
            { name: "Agarwal Law House", contact: "2451415, 2457826" },
            { name: "Alia Law Agency", contact: "2222151, 2282622 - 9415216677" },
            { name: "Modern Bazar", contact: "2219357, 2202299" }
        ]
    },
    {
        city: "LUDHIANA",
        dealers: [
            { name: "Arora Law Agency", contact: "2440390, 5195373 - 9888040390" },
            { name: "Chetan Book Traders", contact: "2521291" },
            { name: "Lyall Book Depot", contact: "2745756" }
        ]
    },
    {
        city: "MADURAI",
        dealers: [
            { name: "Bama Law Enterpises", contact: "2349801 - 9842273412" },
            { name: "National Law Book Agency", contact: "2336166 - 9842117798" },
            { name: "Roja Law Books", contact: "934465099" },
            { name: "Shulka Law House", contact: "538170" }
        ]
    },
    {
        city: "MEERUT",
        dealers: [
            { name: "Law Book Traders", contact: "2421589 - 9897128612" },
            { name: "Western Law House", contact: "2640778 - 9358401993" },
            { name: "Law Book House (Mr. Shariq)", contact: "9837353769" }
        ]
    },
    {
        city: "MUMBAI",
        dealers: [
            { name: "Bhayani Book Depot", contact: "22050884, 22014824 - 9892810455" },
            { name: "Jaina Book Agency (India)", contact: "22012143, 22018485 - 9821040615" },
            { name: "M. & J. Services", contact: "24134216, 24134450 - 9004029495" },
            { name: "Student Agencies (I) Pvt. Ltd.", contact: "24903334, 24903335, 24903336" },
            { name: "Student Book Centre", contact: "22050510, 22080668 - 9820139068" },
            { name: "Swamy Book House", contact: "9920144545" },
            { name: "Vora Book Stall", contact: "22070181, 2201660" }
        ]
    },
    {
        city: "NAGPUR",
        dealers: [
            { name: "Shanti Law House", contact: "2538647, 2560698 - 7122460698" }
        ]
    },
    {
        city: "NASIK",
        dealers: [
            { name: "Maharashtra Law Agency", contact: "2580607, 2314689" },
            { name: "Vishal Book Centre", contact: "2500725" }
        ]
    },
    {
        city: "NEW DELHI",
        dealers: [
            { name: "Aditya Book Pvt. Ltd.", contact: "51724129-0, 29849132, 29845890" },
            { name: "Aggarwal Law House", contact: "23379102, 23378249, 23370861" },
            { name: "Allied Book Co.", contact: "23957876, 23959639" },
            { name: "Capital Publishing House", contact: "23974594, 23959238" },
            { name: "Commercial House", contact: "23947863, 23947862" },
            { name: "Jain Book Agency (South End)", contact: "26567066, 26566113" },
            { name: "Jain Book Agency", contact: "23416390, 23416391-4" },
            { name: "Krishna Law House", contact: "23919317, 23969866" },
            { name: "Niranjan Lal Sharma", contact: "27569910" },
            { name: "Pooja Law House", contact: "23370152, 23379103" },
            { name: "Shanti Law BK Emp.", contact: "23670842, 23518606" },
            { name: "Standard Book Co.", contact: "23414447, 23413899" },
            { name: "Universal Book Traders", contact: "23961288, 23911966" },
            { name: "NCBA Exports", contact: "26493326 - 27" },
            { name: "Consortium Books", contact: "9873879211" },
            { name: "Commercial Book House", contact: "23267860, 23267862" },
            { name: "Ekta Book Co.", contact: "9811048086" },
            { name: "International Book House Pvt. Ltd.", contact: "23243815" },
            { name: "Book Khoj", contact: "23324142, 23324153" }
        ]
    },
    {
        city: "PATNA",
        dealers: [
            { name: "Law Corner", contact: "2231791" },
            { name: "Laws & Laws", contact: "22237737" },
            { name: "Malhotra Books", contact: "2230566" },
            { name: "Malhotra Bros.", contact: "2222914, 2233952" },
            { name: "Pritam Law House Pvt. Ltd.", contact: "2320126, 9431072062 - 9431033336" },
            { name: "Shukla & Co.", contact: "2274663" },
            { name: "Pahuja & Co. Mr. Raju", contact: "9470316880, 9308194881" },
            { name: "Vinayak Book Dist", contact: "9431018020" }
        ]
    },
    {
        city: "PUNE",
        dealers: [
            { name: "Ajit Law Book Depot", contact: "4451546, 44533514, 4017685" },
            { name: "Hind Law House", contact: "24453920, 24456535 - 9823029539" },
            { name: "Ekta Law Book Agency", contact: "4458424 , 4022894" }
        ]
    },
    {
        city: "PUNJAB",
        dealers: [
            { name: "Shree Nath Ji Law House, Bathinda, C.P.Kabra", contact: "9872894452" }
        ]
    },
    {
        city: "RAIPUR",
        dealers: [
            { name: "Agarwal Traders & Publishers", contact: "2234677, 2533716, 2536059" },
            { name: "India Publishing Co.", contact: "2526603, 2522532" }
        ]
    },
    {
        city: "RANCHI",
        dealers: [
            { name: "Crown Book Depot", contact: "2203275" },
            { name: "Pritam Law House", contact: "2246406" }
        ]
    },
    {
        city: "THIRUVANANTHAPURAM",
        dealers: [
            { name: "Sukumar Book Stall", contact: "2330500" },
            { name: "Neethi Law House", contact: "9961975922" }
        ]
    },
    {
        city: "VIJAYAWADA",
        dealers: [
            { name: "Deccan Law House", contact: "2576242, 5521432 - 8666616242" }
        ]
    },
    {
        city: "VISAKHAPATNAM",
        dealers: [
            { name: "Vinod Law House", contact: "2745864 - 9849690878" }
        ]
    }
];

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=DM+Sans:wght@300;400;500&display=swap');

  .dn-section {
    background: #faf8f4;
    padding: 80px 0 100px;
    font-family: 'DM Sans', sans-serif;
    position: relative;
  }

  .dn-section::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, #1a3a2a 0%, #c9a84c 50%, #1a3a2a 100%);
  }

  .dn-header {
    text-align: center;
    margin-bottom: 64px;
    padding: 0 24px;
  }

  .dn-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #c9a84c;
    margin-bottom: 16px;
  }

  .dn-eyebrow::before,
  .dn-eyebrow::after {
    content: '';
    display: block;
    width: 32px;
    height: 1px;
    background: #c9a84c;
  }

  .dn-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: clamp(36px, 5vw, 54px);
    font-weight: 600;
    color: #1a3a2a;
    line-height: 1.1;
    margin: 0 0 16px;
    letter-spacing: -0.01em;
  }

  .dn-subtitle {
    font-size: 15px;
    font-weight: 300;
    color: #6b7c6b;
    max-width: 500px;
    margin: 0 auto;
    line-height: 1.6;
  }

  .dn-stats {
    display: flex;
    justify-content: center;
    gap: 48px;
    margin-top: 40px;
    padding-top: 32px;
    border-top: 1px solid #e2ddd5;
  }

  .dn-stat {
    text-align: center;
  }

  .dn-stat-num {
    font-family: 'Cormorant Garamond', serif;
    font-size: 32px;
    font-weight: 700;
    color: #1a3a2a;
    line-height: 1;
  }

  .dn-stat-label {
    font-size: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #9aaa9a;
    margin-top: 4px;
  }

  .dn-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 32px;
  }

  .dn-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 2px;
    background: #e2ddd5;
    border: 2px solid #e2ddd5;
  }

  .dn-card {
    background: #faf8f4;
    padding: 32px;
    transition: background 0.2s ease;
    position: relative;
    overflow: hidden;
  }

  .dn-card::after {
    content: '';
    position: absolute;
    bottom: 0; left: 32px; right: 32px;
    height: 0;
    background: #1a3a2a;
    transition: height 0.25s ease;
  }

  .dn-card:hover {
    background: #fff;
    z-index: 1;
  }

  .dn-card:hover::after {
    height: 3px;
  }

  .dn-city-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e2ddd5;
  }

  .dn-city-name {
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    font-weight: 700;
    color: #1a3a2a;
    letter-spacing: 0.04em;
    line-height: 1.2;
  }

  .dn-city-badge {
    background: #1a3a2a;
    color: #c9a84c;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.08em;
    padding: 3px 8px;
    border-radius: 2px;
    white-space: nowrap;
    margin-top: 2px;
  }

  .dn-dealers {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .dn-dealer {
    padding: 10px 0;
    border-bottom: 1px dashed #e2ddd5;
  }

  .dn-dealer:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  .dn-dealer-name {
    font-size: 13.5px;
    font-weight: 500;
    color: #2c2c2c;
    line-height: 1.3;
    margin-bottom: 4px;
  }

  .dn-dealer-contact {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 12px;
    font-weight: 300;
    color: #7a8c7a;
    line-height: 1.5;
  }

  .dn-phone-icon {
    flex-shrink: 0;
    margin-top: 2px;
    color: #c9a84c;
  }

  @media (max-width: 640px) {
    .dn-grid {
      grid-template-columns: 1fr;
    }
    .dn-stats {
      gap: 24px;
    }
    .dn-container {
      padding: 0 16px;
    }
  }
`;

export default function DealersNetwork() {
    const totalDealers = dealersData.reduce((sum, c) => sum + c.dealers.length, 0);

    return (
        <>
            <style>{styles}</style>
            <section className="dn-section">
                <div className="dn-header">
                    <div className="dn-eyebrow">Authorised Distribution</div>
                    <h2 className="dn-title">Our Dealers Network</h2>
                    <p className="dn-subtitle">
                        Trusted legal booksellers across India — find an authorised dealer near you.
                    </p>
                    <div className="dn-stats">
                        <div className="dn-stat">
                            <div className="dn-stat-num">{dealersData.length}</div>
                            <div className="dn-stat-label">Cities</div>
                        </div>
                        <div className="dn-stat" style={{ borderLeft: '1px solid #e2ddd5', paddingLeft: 48 }}>
                            <div className="dn-stat-num">{totalDealers}</div>
                            <div className="dn-stat-label">Dealers</div>
                        </div>
                        <div className="dn-stat" style={{ borderLeft: '1px solid #e2ddd5', paddingLeft: 48 }}>
                            <div className="dn-stat-num">All India</div>
                            <div className="dn-stat-label">Coverage</div>
                        </div>
                    </div>
                </div>

                <div className="dn-container">
                    <div className="dn-grid">
                        {dealersData.map((data, index) => (
                            <div key={index} className="dn-card">
                                <div className="dn-city-row">
                                    <div className="dn-city-name">{data.city}</div>
                                    <div className="dn-city-badge">
                                        {data.dealers.length} {data.dealers.length === 1 ? 'dealer' : 'dealers'}
                                    </div>
                                </div>
                                <div className="dn-dealers">
                                    {data.dealers.map((dealer, dIndex) => (
                                        <div key={dIndex} className="dn-dealer">
                                            <div className="dn-dealer-name">{dealer.name}</div>
                                            <div className="dn-dealer-contact">
                                                <svg className="dn-phone-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.11 12 19.79 19.79 0 0 1 1.04 3.38 2 2 0 0 1 3 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                                                </svg>
                                                {dealer.contact}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}